import { useIsomorphicEffect } from '@codeleap/common'
import { useState } from 'react'

import { useFirebase } from '@/utils/hooks/useFirebase'

export const useFirebaseUser = (timeout = 3000) => {
  const firebase = useFirebase()
  const [timedOut, setTimedOut] = useState(false)

  const [firebaseUser, setFirebaseUser] = useState(() => {
    if (!firebase) return undefined

    return firebase.auth().currentUser
  })

  useIsomorphicEffect(() => {
    if (!firebase) return

    let timeoutId = setTimeout(() => {
      setTimedOut(true)
      timeoutId = null
    }, timeout)

    const unsubscribe = firebase.auth().onAuthStateChanged(user => {
      setFirebaseUser(user)

      if (timeoutId && !!user) {
        clearTimeout(timeoutId)
      }
    })

    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId)
      }

      unsubscribe()
    }
  }, [!!firebase, timeout])

  if (timedOut) return null

  return firebaseUser
}
